<template>
  <section class="about">
    <AppAboutHeader />
    <AppAboutDiscoverUs />
    <AppAboutContactUs />
    <AppAboutUserFeedPacks />
    <AppFooter />
  </section>
</template>

<script>
import AppAboutHeader from '@/components/about/Header';
import AppAboutDiscoverUs from '@/components/about/DiscoverUs';
import AppAboutContactUs from '@/components/about/Contact';
import AppAboutUserFeedPacks from '@/components/about/UserFeedpacks';
import AppFooter from '@/components/footer/Footer';

export default {
  name:'about_us',
  components:{
    AppAboutHeader,
    AppAboutDiscoverUs,
    AppAboutContactUs,
    AppAboutUserFeedPacks,
    AppFooter
  }
}
</script>